import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import { CarritoProvider } from './context/CarritoContext';

/*
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CarritoProvider>
          <App />
    </CarritoProvider>
  </React.StrictMode>
);

*/
const root = document.getElementById('react-root');
if (root) {
  ReactDOM.createRoot(root).render(<CarritoProvider><App /></CarritoProvider>);
}


if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js")
    .then(reg => console.log("SW registrado", reg))
    .catch(err => console.log("SW error", err));
}


reportWebVitals();
